/**
 * 流程
 */

import { FullChildContainer } from '@acgn/herm/src/components';

const flowRoutes: any = {
  path: 'comic-flow',
  name: '流程设置',
  icon: 'ift-circle',
  hidden: true,
  meta: {
    breadcrumbHidden: true
  },
  component: FullChildContainer,
  children: [
    {
      path: '',
      redirect: 'edit'
    },
    {
      path: 'edit',
      name: 'desk-flowEdit',
      hidden: true,
      meta: {
        text: '流程设置',
        type: 'edit',
        role: ['5002']
      },
      component: () => import('../views/flow/edit.vue')
    },
  ]
};

export {
  flowRoutes
};
